<template>
  <navbar-component />
  <main class="container-xxl demand-letter-container pt-4 pb-4">
    <matter-submit v-if="!isGeneralInfoFetched" @submit="handleMatterSubmit" />
    <matter-name :matter-name="matterName" />
    <general-info
      v-if="isGeneralInfoFetched"
      :matter-name="matterName"
      :inputs-data="generalInfoInputs"
      :templates="templates"
      :recommended-template-name="templateName"
      :additional-info="additionalInfo"
    />
  </main>
</template>

<script lang="ts">
import NavbarComponent from '@/components/Navbar.vue';
import MatterSubmit from '@/components/MatterSubmit.vue';
import GeneralInfo from '@/components/GeneralInfo.vue';
import MatterName from '@/components/MatterName.vue';
import generalInfoMixin from '@/mixins/generalInfoMixin';
import { defineComponent } from 'vue';
import { MatterSubmitResponse } from '@/types/MatterSubmitResponse';

export default defineComponent({
  name: 'NewSession',

  components: {
    MatterName,
    NavbarComponent,
    GeneralInfo,
    MatterSubmit,
  },

  mixins: [generalInfoMixin],

  data() {
    return {
      templates: [] as string[],
      recommendedTemplateName: '',
    };
  },

  methods: {
    handleMatterSubmit(matterSubmitResponse: MatterSubmitResponse) {
      if (matterSubmitResponse) {
        const generalInfo = {
          matterInfo: matterSubmitResponse.matterInfo,
          damage: null,
          templateName: matterSubmitResponse.recommendedTemplateName,
        };

        this.setGeneralInfo(generalInfo);
        this.templates = matterSubmitResponse.templates;
      }
    },
  },
});
</script>

<style scoped>
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

p {
  margin: 0;
  font-size: 16px;
  color: #333;
}
</style>
